var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWakaru = function SvgWakaru(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_456_4303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.64286 18.75C7.64286 19.1625 7.99643 19.5 8.42857 19.5H11.5714C12.0036 19.5 12.3571 19.1625 12.3571 18.75V18H7.64286V18.75ZM10 4.5C6.96714 4.5 4.5 6.855 4.5 9.75C4.5 11.535 5.435 13.1025 6.85714 14.055V15.75C6.85714 16.1625 7.21071 16.5 7.64286 16.5H12.3571C12.7893 16.5 13.1429 16.1625 13.1429 15.75V14.055C14.565 13.1025 15.5 11.535 15.5 9.75C15.5 6.855 13.0329 4.5 10 4.5ZM12.2393 12.825L11.5714 13.275V15H8.42857V13.275L7.76071 12.825C6.7 12.12 6.07143 10.9725 6.07143 9.75C6.07143 7.68 7.83143 6 10 6C12.1686 6 13.9286 7.68 13.9286 9.75C13.9286 10.9725 13.3 12.12 12.2393 12.825Z",
    fill: "#90A2AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 -3.27834e-08C10.4142 -1.46776e-08 10.75 0.335786 10.75 0.75L10.75 2.25C10.75 2.66421 10.4142 3 10 3C9.58579 3 9.25 2.66421 9.25 2.25L9.25 0.75C9.25 0.335786 9.58579 -5.08892e-08 10 -3.27834e-08Z",
    fill: "#90A2AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75836 2.36337C4.05125 2.07048 4.52613 2.07048 4.81902 2.36337L5.87968 3.42403C6.17257 3.71692 6.17257 4.1918 5.87968 4.48469C5.58679 4.77758 5.11191 4.77758 4.81902 4.48469L3.75836 3.42403C3.46547 3.13114 3.46547 2.65626 3.75836 2.36337Z",
    fill: "#90A2AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2422 2.36338C16.5351 2.65627 16.5351 3.13114 16.2422 3.42404L15.1815 4.4847C14.8886 4.77759 14.4138 4.77759 14.1209 4.4847C13.828 4.1918 13.828 3.71693 14.1209 3.42404L15.1815 2.36338C15.4744 2.07048 15.9493 2.07048 16.2422 2.36338Z",
    fill: "#90A2AC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_456_4303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export default SvgWakaru;